import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject  } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressSpinnerService {

  private isVisible$ = new BehaviorSubject<boolean>(false);

  setVisibility(value: boolean){
    this.isVisible$.next(value);
  }

  geVisibility$(): Observable<boolean>{
    return this.isVisible$.asObservable();
  }
}
